
import SocialTwitter from './SocialTwitter'
import SocialFacebook from './SocialFacebook'
import SocialWhatsapp from './SocialWhatsapp'
import SocialTelegram from './SocialTelegram'
import SocialPinterest from './SocialPinterest'
import SocialReddit from './SocialReddit'
import SocialEmail from './SocialEmail'
export default {
  name: 'social',
  components: {
    SocialTwitter,
    SocialFacebook,
    SocialWhatsapp,
    SocialTelegram,
    SocialPinterest,
    SocialReddit,
    SocialEmail
  },
  props: {
    facebook: { type: Boolean, default: !1 },
    twitter: { type: Boolean, default: !1 },
    telegram: { type: Boolean, default: !1 },
    whatsapp: { type: Boolean, default: !1 },
    pinterest: { type: Boolean, default: !1 },
    email: { type: Boolean, default: !1 },
    linkedin: { type: Boolean, default: !1 },
    reddit: { type: Boolean, default: !1 },
    top: { type: Boolean, default: !1 },
    bottom: { type: Boolean, default: !1 },
    right: { type: Boolean, default: !1 },
    left: { type: Boolean, default: !1 },
    direction: { type: String, default: 'bottom' },
    hover: { type: Boolean, default: !1 },
    color: { type: String, default: 'primary' },
    small: { type: Boolean, default: !1 },
    transition: { type: String, default: 'slide-y-transition' },
    url: {
      type: String,
      async default() {
        return await window.location.href
      }
    },
    title: { type: String, default: '' },
    tooltip: { type: String, default: 'Compartilhar' },
    align: { type: String, default: 'float-right' }
  },
  data() {
    return {
      fab: !1
    }
  }
}
